const tracksEN = {
    "view": {
        "table": {
            "title": "Edit Tracks",
            "column": {
                "name": "Name",
                "mixName": "Mix Name",
                "mixLength": "Mix Length",
                "player": "Player",
                "status": "Status",
                "accStatus": "Acc Status",
                "qc": "QC",
                "action": "Action"
            },
            "button": {
                "edit": "Edit",
                "goToReleases": "Go To Releases",
                "distribute": "Distribute",
                "submitEditing": "Submit Editing",
                "statusReady": "Ready",
                "statusNotReady": "Not Ready"
            },
            "message": {
                "identityNotCheckedTooltip": "You have not yet provided your complete information, therefore you can't distribute the releases. In order to do so kindly Submit Your Information.",
                "tracksNotReadyTooltip": "Please submit the metadata for all Tracks in order to Distribute the Release.",
                "tracksNotReadyForEditingTooltip": "Please submit the metadata for all tracks, in order to Submit the Edits.",
                "distributionDisabledPreScanInProgressTooltip": "Please wait for the pre scan to complete first in order to distribute the release.",
                "distributionDisabledPreScanNotDoneTooltip": "Please perform pre scan first in order to distribute the release.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Please submit the pre-scan declaration first in order to distribute the release.",
                "browserNotSupported": "Your browser does not support the audio element.",
                "trackUpdated": "Track has been updated!"
            },
            "modal": {
                "distribute": {
                  "header": "Are you sure all information entered is valid and represents this release fully?",
                  "body": {
                    "point1": "After this action, your release will be checked and if the information is correct it will be distributed on the official and exclusive distribution dates.",
                    "point2": "By confirming and accepting this form, you are fully accepting and complying with the <1>Terms Of Distribution</1>, <3>Terms Of Use</3> and <5>Privacy Policy</5>.",
                    "point3": "By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.",
                    "point4": "Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute.",
                    "flaggedTracksTerms": {
                      "header": "Flagged Tracks Terms",
                      "point1": "Please note: <strong>'{{releaseName}}'</strong> contains one or more flagged tracks, A fee of <strong>15 €</strong> per flagged track applies in order to deliver the release to <strong>Spotify</strong>. As you have opted not to pay this fee at this time, the release will not be delivered to Spotify. By confirming and accepting this form, you acknowledge and accept these terms.",
                      "point2": "In future if you opt for the release to be delivered to <strong>Spotify</strong> you can go to the Flagged section in Releases table and follow the payment prompts.",
                    },
                    "artificialStreamingDeclaration": {
                      "header": "Artificial Streaming Declaration",
                      "point1": "<strong>1.</strong> I fully understand and agree not to engage in any form of artificial streaming, including the use of bots, streaming farms, or any method that manipulates DSP metrics.",
                      "point2": "<strong>2.</strong> I will not pay or offer payment for playlist placements, nor will I work with any third party promising guaranteed placements — I understand this is considered fraud and a scam.",
                      "point3": "<strong>3.</strong> I acknowledge that any such actions may result in immediate termination, forfeiture of royalties, legal claims, contractual penalties and fees, and reporting to DSPs and authorities.",
                      "point4": "<strong>4.</strong> I also guarantee to inform and educate any artists or clients I work with about these rules and ensure they comply.",
                      "point5": "<strong>5.</strong> I understand that if I engage in artificial streaming, my KYC data, including my full name, address, ID card, and other personal information, can be shared with the DSP's legal departments, such as those of Spotify, Apple Music, and others.",
                      "point6": "<strong>6.</strong> I accept full legal responsibility for any violations.",
                      "acknowledgment": "I hereby acknowledge and agree to abide by the above Artificial Streaming terms, and I accept full legal responsibility for any violations.",
                    },
                  },
                  "button": {
                    "cancel": "Cancel",
                    "confirm": "Confirm and Accept"
                }
                },
                "finishEditing": {
                    "header": "Are you sure all information entered is valid and represents this release fully?",
                    "body": {
                        "point1": "After this action, your release will be checked and if the information is correct it will be re-distributed to the DSP partners. <strong>NOTE, only METADATA will be sent to DSP-s, content such as IMAGE and AUDIO files can not be updated this way.</strong>",
                        "point2": "By confirming and accepting this form, you are fully accepting and complying with the <1>Terms Of Use</1> and Terms of our Exclusive Distribution Agreement.",
                        "point3": "By confirming and accepting this form, you are fully accepting and complying with the <1>Privacy Policy</1>.",
                        "point4": "By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.",
                        "point5": "Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute."
                    },
                    "button": {
                        "cancel": "Cancel",
                        "confirm": "Confirm and Accept"
                    }
                }
            },
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Edit track {{trackName}}",
                "mandatoryMetadata": "Mandatory Metadata",
                "required": "Required",
                "trackName": "Track Name",
                "mixName": "Mix Name",
                "originalmix": "Original Mix",
                "remix": "This is a Remix or Mix",
                "vocals": "Vocals",
                "genre": "Genre",
                "subGenre": "Sub-Genre",
                "additionalMetadata": "Additional Metadata",
                "copyright": "Copyright ©",
                "copyrightYear": "Copyright Year",
                "albumOnly": "Album Only",
                "explicitContent": "Explicit Content",
                "isrc": "ISRC",
                "daIsrc": "Dolby Atmos ISRC",
                "generateIsrc": "Generate ISRC",
                "trackLanguageMetadata": "Track Language Metadata",
                "language": "Language",
                "autoDetectLanguage": "Auto Detect (Language)",
                "accountingData": "Accounting Data",
                "labelShare": "Label Share (%)"
            },
            "placeholder": {
                "select": "Select...",
                "labelShare": "i.e. 50"
            },
            "help_text": {
                "trackName": "Title of the track",
                "mixName": "Insert mix name without brackets. Some tracks are released in more than one version. This Field describes the version, for example 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Listen to your track in full length. If your track is having any vocals, please select the language of vocals. If your track is free of vocals, select the Instrumental option. Double check it to be sure. If this input is wrong, some stores like iTunes and Apple Music will reject the release.",
                "publishers": {
                    "publisherName": "<strong>Publisher name:</strong> Please insert full Publishing Company Name if you are using publishing services.  If you are not using official publishing services, please insert/select <strong>Copyright Control</strong>. Please <strong>do not insert your label name</strong> if it is not a registered publishing company. Legal implications may apply.",
                    "authorSongWriterName": "<strong>Author / Songwriter full name:</strong> Please insert the <strong>real First and Last name</strong> of the person."
                },
                "contributors": {
                    "contributorsName": "<strong>Contributors name:</strong> Please insert the <strong>real First and Last name</strong> of the person.",
                    "contributorsRoles": "<strong>Contributors roles:</strong> At least one contributor must be added as a <strong>Composer</strong>. If your track consists of vocals, least one contributor must be added as a <strong>Composer</strong> and one contributor must be added as a <strong>Lyricist</strong>."
                },
                "copyright": "Copyright holder name",
                "albumOnly": "Indicates whether the track will be sold only as part of bundle release. Note that some shops could override this instruction",
                "explicitContent": "Please mark this field if track has prohibited lyrics",
                "isrc": "The International Standard Recording Code assigned for the track. If you don´t have your own, we will generate one for you",
                "daIsrc": "The International Standard Recording Code assigned for the track. If you don´t have your own, we will generate one for you",
                "language": "In which language is the track name written? Please double check if you are not sure. If this input is wrong, some stores like iTunes and Apple Music will reject the release.",
                "labelShare": "<strong>Tipp:</strong> The industry standard for <strong>label share</strong> is <strong>50%</strong> and <strong>50%</strong> for the <strong>shareholders</strong>. We strongly advise you to insert the accurate percentage share to which you have agreed with your artists, shareholders, and partners.",
                "costTypes": {
                    "point1": "Insert only actual, occurred, or pre-agreed <strong>Costs</strong> per track. We strongly advise you not to insert false costs.",
                    "point2": "<strong>Cost types</strong> could be any fixed or variable costs i.e. <strong>Audio Mastering, Graphic Design, Promotion, Marketing</strong>, or any other viable expenditure spent for the particular <strong>Track</strong> by the <strong>Label</strong>."
                }
            },
            "button": {
                "submitTrack": "Submit Track"
            },
            "message": {
                "successArtistAdded": "A new Artist has been added!",
                "successPublisherAdded": "A new Publisher has been added!",
                "successContributorAdded": "A new Contributor has been added!",
                "successShareholderAdded": "A new Shareholder has been added!",
                "successCostTypeAdded": "A new Cost Type has been added!",
                "errorLabelShareInvalid": "Please enter a valid value (1-100)",
                "errorFormCannotBeSubmitted": "Form cannot be submited! Please fill all fields and check errors!",
                "accountingMetadata": {
                    "title": "WARNING",
                    "description": {
                        "point1": "OPTIONAL METADATA - fill in this part of the metadata only if you will issue accounting reports to your artists or shareholders!",
                        "point2": "Please make sure that the submitted data in this section is fully accurate, as it will affect the reports you will send to your artists and shareholders.",
                        "point3": "We strongly recommend double-checking the inputs as after submission, additional editing and changes are not recommended for the sake of data accuracy.",
                        "point4": "Accounting reports for your artists and shareholders will have an accurate effect only if you submit all parameters correctly and according to your deals with your artists and shareholders.",
                        "point5": "Costs could be added only once and can not be edited later for transparency and accuracy reasons. Make sure to insert all track costs accurately on your first try.",
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Publishers",
                "required": "Required",
                "order": "Order",
                "publisherName": "Publisher name",
                "authorSongWriterName": "Author / Songwriter full name"
            },
            "placeholder": {
                "publisherName": "Select Publisher...",
            },
            "button": {
                "addAnother": "Add another",
                "createNew": "Create new?",
                "remove": "Remove"
            },
            "message": {
                "publisherRequired": "Please select publisher",
                "authorSongWriterRequired": "Please insert the real First and Last name of the person."
            },
            "modal": {
                "header": "Add new Publisher",
                "body": {
                    "label": {
                        "name": "Name"
                    },
                    "message": {
                        "nameRequired": "Name is required",
                        "publisherAlreadyExists": "Publisher already exists"
                    }
                },
                "button": {
                    "createNew": "Create new",
                    "cancel": "Cancel"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Contributors",
                "required": "Required",
                "order": "Order",
                "contributorName": "Contributor full name",
                "contributorRole": "Contributor role"
            },
            "placeholder": {
                "contributorName": "Select Contributor...",
            },
            "button": {
                "addAnother": "Add another",
                "createNew": "Create new?",
                "remove": "Remove"
            },
            "modal": {
                "header": "Add new Contributor",
                "body": {
                    "label": {
                        "name": "Name"
                    },
                    "help_text": {
                        "name": "Please insert the full First and Last name of the songwriter. Example: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Name is required",
                        "nameMustNotBeInUppercase": "Name must not be in all uppercase",
                        "insertRealName": "Please insert the real First and Last name of the person.",
                        "errorContributorAlreadyExists": "Contributor already exists"
                    }
                },
                "button": {
                    "createNew": "Create new",
                    "cancel": "Cancel"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Order",
                "shareholders": "Shareholders",
                "shareholderName": "Shareholder Name",
                "shareholderSplit": "Shareholder Split (%)",
                "shareholderRoles": "Shareholder Roles"
            },
            "placeholder": {
                "shareholderName": "Select Shareholder...",
                "shareholderSplit": "i.e. 50"
            },
            "message": {
                "shareholderRequired": "Please select shareholder",
                "shareholderSplitRequired": "Please enter a valid value (1-100)",
                "shareholderRolesRequired": "Please select atleast one role",
                "shareSum": "Label Share and Shareholder Splits should add up to 100%"
            },
            "button": {
                "addAnother": "Add another",
                "createNew": "Create new?",
                "remove": "Remove"
            },
            "modal": {
                "header": "Add new Shareholder",
                "body": {
                    "label": {
                        "name": "Name",
                        "email": "Email"
                    },
                    "help_text": {
                        "name": "Please insert the full First and Last name of the songwriter. Example: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Name is required",
                        "emailRequired": "Email is required",
                        "emailInvalid": "Email is not valid"
                    }
                },
                "button": {
                    "createNew": "Create new",
                    "cancel": "Cancel"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Cost Types",
                "order": "Order",
                "costType": "Cost Type",
                "cost": "Cost (€)"
            },
            "placeholder": {
                "costType": "Select Cost Type...",
                "cost": "i.e. -7.5"
            },
            "button": {
                "addAnother": "Add another",
                "createNew": "Create new?",
                "remove": "Remove"
            },
            "message": {
                "costTypeRequired": "Please select cost type",
                "costNotNegative": "Please enter a negative value i.e. -10.0"
            },
            "modal": {
                "header": "Add New Cost Type",
                "body": {
                    "label": {
                        "name": "Name"
                    },
                    "message": {
                        "nameRequired": "Name is required",
                        "costTypeAlreadyExists": "Cost type already exists"
                    },
                    "button": {
                        "createNew": "Create new",
                        "cancel": "Cancel"
                    }
                },
                
            }
        }
    }
};

export default tracksEN;